import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Producto/cambiarEstadoProductoSeleccion`, method: 'POST', body: values, token: token})
}